import Vue from 'vue'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip, {
  // enabled: window.innerWidth > 768,
  defaultBoundariesElement: document.body
})
